import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

import { FIXABLE_ISSUES } from '../lib/fix-copy';

const listChannels = (names) => {
	if (names.length <= 1) return names[0] ?? 'This channel';
	return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

/**
 * Single-issue Fix dialog, opened from either the Issues card (where the issue
 * is the subject and `requiredBy` is every channel it blocks) or a Visibility
 * row's Fix button (where the channel is the subject and `alsoNeeds` lists the
 * channel's remaining issues, so one fix isn't mistaken for full eligibility).
 */
export function FixIssueDialog({ issue, onApply, onClose }) {
	const entry = issue ? FIXABLE_ISSUES[issue.type] : null;

	return (
		<Dialog open={!!entry} onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="rounded-2xl sm:max-w-md">
				{entry ? (
					<>
						<div>
							<span
								data-testid="fix-dialog-eligibility"
								className="inline-flex items-center rounded-full bg-warning-soft px-2.5 py-1 text-xs font-semibold text-warning-soft-foreground"
							>
								Not eligible
							</span>
						</div>
						<DialogHeader>
							<DialogTitle className="text-xl font-bold">Fix {entry.fieldLabel.toLowerCase()}</DialogTitle>
							<DialogDescription>
								{listChannels(issue.requiredBy ?? [])} require{(issue.requiredBy ?? []).length === 1 ? 's' : ''}{' '}
								{entry.fieldLabel.toLowerCase()} to show this product. {entry.reason}
							</DialogDescription>
						</DialogHeader>
						<div className="rounded-xl border border-border/60 bg-muted/60 px-4 py-3 text-xs leading-relaxed text-muted-foreground">
							{entry.steps}
						</div>
						{issue.alsoNeeds?.length ? (
							<p data-testid="fix-dialog-also-needs" className="text-xs text-muted-foreground">
								This channel also needs:{' '}
								{issue.alsoNeeds.map((type) => FIXABLE_ISSUES[type].fieldLabel.toLowerCase()).join(', ')}.
							</p>
						) : null}
						<div className="flex items-center justify-end gap-2">
							<button
								type="button"
								onClick={onClose}
								className="inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold text-foreground transition hover:bg-muted"
							>
								Cancel
							</button>
							<button
								type="button"
								onClick={() => onApply(entry.field)}
								className="inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition hover:bg-primary/90"
							>
								{entry.cta}
							</button>
						</div>
					</>
				) : null}
			</DialogContent>
		</Dialog>
	);
}
